module.exports = __webpack_public_path__ + "static/blog-d55a0a39bd98848c711cea6558a65953.jpg";